module.exports = __webpack_public_path__ + "static/media/astronaut.0e4414e3.svg";